"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProxyFactoryAddress = exports.getDocumentStoreCreatorAddress = exports.PROXY_FACTORY_ROPSTEN = exports.PROXY_FACTORY_MAINNET = exports.DOCUMENT_STORE_CREATOR_ROPSTEN = exports.DOCUMENT_STORE_CREATOR_MAINNET = void 0;
const DOCUMENT_STORE_CREATOR_ROPSTEN = exports.DOCUMENT_STORE_CREATOR_ROPSTEN = "0x4077534e82C97Be03A07FB10f5c853d2bC7161FB";
const DOCUMENT_STORE_CREATOR_MAINNET = exports.DOCUMENT_STORE_CREATOR_MAINNET = "0x0";
const PROXY_FACTORY_ROPSTEN = exports.PROXY_FACTORY_ROPSTEN = "0xba2501bf20593f156879c17d38b6c245ca65de80";
const PROXY_FACTORY_MAINNET = exports.PROXY_FACTORY_MAINNET = "0x0";
const getDocumentStoreCreatorAddress = networkId => {
  if (networkId === 3) return DOCUMENT_STORE_CREATOR_ROPSTEN;
  return DOCUMENT_STORE_CREATOR_MAINNET;
};
exports.getDocumentStoreCreatorAddress = getDocumentStoreCreatorAddress;
const getProxyFactoryAddress = networkId => {
  if (networkId === 3) return PROXY_FACTORY_ROPSTEN;
  return PROXY_FACTORY_MAINNET;
};
exports.getProxyFactoryAddress = getProxyFactoryAddress;